module.exports = __webpack_public_path__ + "img/user-small.15be0a53.svg";